"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var react_1 = __importDefault(require("react"));
var test_attributes_1 = require("@hip/test-attributes");
var halcyon_components_react_1 = require("@realm-kf/halcyon-components-react");
var year = new Date().getFullYear();
var Footer = function () { return (react_1.default.createElement("div", { className: "hlcn-u-p-component-small hlcn-u-bgc-deal-dark", "data-test-id": test_attributes_1.dataTestId.configurator.layout.footer },
    react_1.default.createElement(halcyon_components_react_1.Text, { size: "xsmall", color: "white", weight: "bold" },
        "\u00A9 B&Q ",
        year))); };
exports.Footer = Footer;
